import React from "react";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";

const foundationData = {
  pageTitle: "Celbion Foundation",
  banner: {
    bgUrl: "/images/about/banner_bg.jpg",
    imgUrl: "/images/doctors/banner_img.png",
    title: "Celbion Foundation",
    subTitle: "Celbion Healthcare’s Commitment to Social Responsibility",
  },
  mainImage: "/images/about/csr_img.jpg",
  heroImage: "/images/about/Foundation-img.png",
  sectionImage: "/images/about/social-img.png",
  paragraphs: [
    "The Foundation is dedicated to supporting the long-term growth and success of the organization while strengthening its position as a trusted name across therapeutic areas.",
    "We extend philanthropic support to encourage and recognize excellence among clinicians and run awareness programmes and screening initiatives focused on public health.",
    "Our ongoing efforts include public education about safe use of medicines and preventive care to improve quality of life for patients.",
  ],
};

export default function Foundation() {
  pageTitle(foundationData.pageTitle || "Celbion Foundation");
  return (
    <>
      <BannerSectionStyle3
        bgUrl={foundationData.banner?.bgUrl}
        imgUrl={foundationData.banner?.imgUrl}
        title={foundationData.banner?.title}
      />

      <Section topMd={80}>
        <div className="container">
          <h2 className="cs_mb_80 text-center" style={{ marginBottom: "80px" }}>
            {foundationData.banner?.subTitle}
          </h2>
          <div>
            <img src={foundationData.heroImage} alt="bannerimg" />
          </div>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-6">
              <div className="cs_image_box">
                <img
                  src={foundationData.sectionImage}
                  alt="Corporate Social Responsibility"
                  style={{ width: "100%", borderRadius: 6 }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="cs_content">
                <p>
                  The Foundation is dedicated to supporting the long-term growth
                  and successof the organization while strengthening its
                  position as a trusted name acrosstherapeutic areas such as
                  Neurology, Psychiatry, Cardiology, Diabetology,
                  and Orthopedics, with a strong focus on delivering meaningful
                  healthcare outcomes.
                </p>
                <p>
                  Alongside this, the Foundation extends philanthropic support
                  to encourage and recognize excellence among clinicians working
                  within our core therapeutic domains.Corporate social
                  responsibility and patient-centric initiatives remain central
                  to our mission. We actively contribute to public health
                  awareness programs related to various CNS disorders and
                  regularly organize Bone Mineral Density (BMD) screening camps
                  to aid in the early detection of osteoporosis.
                </p>
                <p>
                  A key focus of our ongoing efforts is to educate the public
                  about the risks associated with the uncontrolled use of
                  painkillers without medical guidance and their harmful effects
                  on vital organs. We continuously promote the message that
                  chronic conditions can be effectivelymanaged, and patients can
                  regain a better quality of life through preventive care
                  andappropriate medication—ultimately contributing to a
                  healthier nation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
